import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSlides } from 'shared/api/slideshowApi';

export const fetchSlides = createAsyncThunk('slideshow/fetchSlides', getSlides);
